var _effectorFileName = "/builds/gmini/front-ui-kit/src/IconButton/IconButton.tsx";
import { forwardRef } from 'react';
import { WarningButton, IconButtonStyled } from './IconButton.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const IconButton = /*#__PURE__*/forwardRef(({
  onClick,
  disabled,
  selected,
  active,
  children,
  type = 'square',
  size = 'small',
  color = 'default',
  seoEvent,
  ...other
}, ref) => /*#__PURE__*/_jsx(ButtonComp, {
  active: active,
  selected: selected,
  disabled: disabled,
  onClick: event => {
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
    seoEvent === null || seoEvent === void 0 ? void 0 : seoEvent();
  },
  isCircle: type === 'circle',
  size: size,
  color: color,
  ref: ref,
  ...other,
  children: children
}));
IconButton.displayName = 'IconButton';
const ButtonComp = /*#__PURE__*/forwardRef(({
  color,
  type,
  ...other
}, ref) => {
  switch (color) {
    case 'warning':
      {
        return /*#__PURE__*/_jsx(WarningButton, {
          ref: ref,
          ...other
        });
      }

    case 'default':
    default:
      {
        return /*#__PURE__*/_jsx(IconButtonStyled, {
          ref: ref,
          ...other
        });
      }
  }
});
ButtonComp.displayName = 'ButtonComp';